











































import Vue, { PropType } from 'vue';
// import { Item } from '@/modules/exhibitor/item';
// import { Brand } from '@/modules/exhibitor/brand';
import {
  Brand,
  Item,
} from 'mostra';

// interface DataType {
//   innerSelectedBrand: string;
// }

export default Vue.extend({
  name: 'GItemTop',
  props: {
    selectedBrand: {
      type: String as PropType<string>,
      required: true,
    },
    brands: {
      type: Array as PropType<Brand[]>,
      default: () => ([]),
    },
    toEditData: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    copyItem: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    previewItem: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    currentIndex: {
      type: Number as PropType<number>,
      default: 1,
    },
    loadsLength: {
      type: Number as PropType<number>,
      default: 0,
    },
    pagerLength: {
      type: Number as PropType<number>,
      default: 0,
    },
    maxDisplayedItemLength: {
      type: Number as PropType<number>,
      default: 30,
    },
    maxPagerLength: {
      type: Number as PropType<number>,
      default: 8,
    },
    listItems: {
      type: Array as PropType<Item[]>,
      default: () => [],
    },
    pagerItems: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    prevPage: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    changePage: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    nextPage: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    setPagerItems: {
      type: Function as PropType<Function>,
      default: () => false,
    },
  },
  computed: {
    brandOptions() {
      const options = this.brands.map((brand: Brand) => ({ value: brand.id, text: brand.data.base.name }));
      return [{ value: '', text: '全ブランドを表示' }, ...options];
    },
    innerSelectedBrand: {
      get(): string {
        return (this as any).selectedBrand;
      },
      set(val: string) {
        (this as any).$emit('filterByBrand', val);
      },
    },
  },
  methods: {
    toCreatePage() {
      this.$router.push({
        name: 'exhibitor-item-new',
        query: { page: 'settings' },
      });
    },
  },
});
